// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import SearchController from "./search_controller"
application.register("search", SearchController)
import EventTypeController from "./event_type_controller"
application.register("event-type", EventTypeController)

import LocationNoteController from "./location_note_controller"
application.register("location-note", LocationNoteController)
